import './assets/main.less'

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import vuetify from './vuetyfy'

const app = createApp(App)

// app.config.globalProperties.$settings = {
//   axiosAuth: {
//     username: 'apache',
//     password: '12345678'
//   }
// }

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
